import React from 'react';
import Sidebar from './Sidebar';
const Starter = () => {
    return <section className='home'>  
    <Sidebar/>
</section>;
};

export default Starter;
